/* global u */

/**
*
* Calculates the height of the fixed portion of UI, including the header, breadcrumbs, and sticky nav
*
*/

export default class HeaderHeightCalculator {
    constructor() {
        this.allVariables = [
          "nav-height-init",
          "breadcrumbs-height-init",
          "inpage-nav-height-init",
        ];
    }

    /**
     * @returns the sum of the heights of all fixed header objects present on the page
     */
    getFullHeaderHeight() {
       return this.allVariables.map(window.cmhrBetaBannerSettings.getCurrentSize).reduce((a, b) => a + b);
    }
}
